(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ar-button"] && !Shopify.designMode) return;
  try {
    if (!window.customElements || !window.customElements.get('model-viewer')) {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
    document.head.appendChild(script);
  }

  
  document.addEventListener("DOMContentLoaded", function () {
    // Select all hotspots
    const hotspots = document.querySelectorAll(".hotspot");

    hotspots.forEach(hotspot => {
      const flyout = hotspot.querySelector(".flyout");

      if (!flyout) return;

      // Toggle on click (for mobile)
      hotspot.addEventListener("click", function (e) {
        e.stopPropagation(); // Prevent bubbling
        const isOpen = flyout.classList.contains("open");

        // Close all other flyouts
        document.querySelectorAll(".flyout.open").forEach(el => {
          el.classList.remove("open");
        });

        // Toggle this one
        if (!isOpen) {
          flyout.classList.add("open");
        }
      });
    });

    // Optional: click outside to close
    document.addEventListener("click", function () {
      document.querySelectorAll(".flyout.open").forEach(el => {
        el.classList.remove("open");
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
